<script setup lang="ts">
defineProps<{ reason?: string; ctx?: unknown }>()
</script>
<template>
  <div class="card disabled-tab-body" data-testid="disabled-tab-body" role="status">
    {{ reason ?? 'Not available' }}
  </div>
</template>
